var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import FormComponentGenerator, { EAnswerInputType, } from "@frameworks/salesjourney/components/Generic/FormComponentGenerator";
import React, { useEffect, useState } from "react";
import di from "./di/serviceLocator";
import DropdownDatePicker from "./DropdownDatePicker";
export var EFormCustomComponent;
(function (EFormCustomComponent) {
    EFormCustomComponent["DATE_RANGE"] = "DATE_RANGE";
    EFormCustomComponent["LABEL"] = "LABEL";
})(EFormCustomComponent || (EFormCustomComponent = {}));
var FieldWrapper = function (props) {
    var _a = __read(useState(undefined), 2), dropDownList = _a[0], setDropDownList = _a[1];
    var _b = __read(useState(null), 2), loader = _b[0], setLoader = _b[1];
    var getDropdownList = function (ddlid, userinput) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                ddlid: ddlid,
                userinput: userinput.toString(),
            };
            setLoader(true);
            di.salesReporting
                .getRmPartnerReportDropdownList(payload)
                .then(function (List) {
                var _a;
                if (((_a = List === null || List === void 0 ? void 0 : List.data) === null || _a === void 0 ? void 0 : _a.length) > 0)
                    setDropDownList(List.data);
                setLoader(false);
            })
                .catch(function (error) {
                setLoader(false);
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.fieldId) &&
            ((props === null || props === void 0 ? void 0 : props.fieldType) === EAnswerInputType.SELECT ||
                (props === null || props === void 0 ? void 0 : props.fieldType) === EAnswerInputType.DROPDOWN_SEARCH)) {
            getDropdownList(props === null || props === void 0 ? void 0 : props.fieldId, (props === null || props === void 0 ? void 0 : props.parentSelectedValue) ? props === null || props === void 0 ? void 0 : props.parentSelectedValue : "");
        }
    }, [props === null || props === void 0 ? void 0 : props.fieldId, props === null || props === void 0 ? void 0 : props.parentSelectedValue]);
    var generateComponent = function () {
        var _a;
        switch ((_a = props === null || props === void 0 ? void 0 : props.fieldType) === null || _a === void 0 ? void 0 : _a.toString()) {
            case EFormCustomComponent.DATE_RANGE:
                return React.createElement(DropdownDatePicker, __assign({}, props === null || props === void 0 ? void 0 : props.fieldDetails));
            case EFormCustomComponent.LABEL:
                return (React.createElement("div", { className: "DMSanN_16_400 d-flex justify-content-end" }, props === null || props === void 0 ? void 0 : props.fieldName));
            default:
                return (React.createElement(FormComponentGenerator, { optionLabel: props === null || props === void 0 ? void 0 : props.fieldName, optionType: props.fieldType, props: __assign(__assign({}, props === null || props === void 0 ? void 0 : props.fieldDetails), { options: dropDownList, isLoading: loader }) }));
        }
    };
    return generateComponent();
};
export default FieldWrapper;
